<template>
  <el-drawer
    class="sideDrawer"
    destroy-on-close
    :size="drawerSize"
    :wrapperClosable="false"
    title="付款单"
    append-to-body
    :visible="show"
    :before-close="beforeCloseDialog"
    @dialogclose="beforeCloseDialog"
    ><i class="iconfont icon-back-quanping iconFull" @click="drawerSize = '100%'" v-if="drawerSize == '70%'" />
    <i @click="drawerSize = '70%'" class="iconfont icon-back-tuichuquanping iconFull" v-else />
    <div slot="title" class="dialog-header-title">
      <span class="name">付款单</span>
    </div>
    <div class="form_content" style="padding: 20px">
      <el-form :model="formData" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-row class="form_head_title"> 客户信息 </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="付款单编号:" prop="payment_no">
              <el-input v-model="formData.payment_no" placeholder="保存后自动生成" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="付款单日期:" prop="payment_time">
              <el-date-picker v-model="formData.payment_time" style="width: 100%" format="yyyy-MM-dd" placeholder="选择日期" disabled> </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="客户名称:" prop="customer_name">
              <el-input v-model="formData.customer_name" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="联系人:" prop="contacts">
              <el-input v-model="formData.contacts" disabled> </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话:" prop="contacts_phone">
              <el-input v-model="formData.contacts_phone" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="form_head_title"> 订单信息 </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="订单编号:" prop="order_no">
              <el-input v-model="formData.order_no" placeholder="保存后自动生成" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订单日期:" prop="order_time">
              <el-date-picker style="width: 100%" v-model="formData.order_time" format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期" disabled> </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="产品名称:" prop="account_name">
              <el-input v-model="formData.account_name" placeholder="保存后自动生成" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订单金额:" prop="order_amount">
              <el-input v-model="formData.order_amount" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="form_head_title"> 付款信息 </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="付款金额:" prop="payment_amount">
              <el-input v-model="formData.payment_amount" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="付款方式:" style="margin-bottom: 0px" prop="pay_method">
              <el-select v-model="formData.pay_method" style="width: 100%" placeholder="请选择" disabled>
                <el-option v-for="item in paymentList" :key="item.code" :label="item.name" :value="item.code"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="上传附件:" prop="attachment">
          <eip-attachment
            v-model="formData.attachment"
            model-name="formData.attachment"
            :permission="'w'"
            propConf='[{"name":"prop1"},{"name":"prop2"},{"name":"prop3"},{"name":"prop4"},{"name":"prop5"},{"name":"prop6"}]'
            accept="jpg,jpeg,png,bmp,pdf,JPG,JPEG,PBG,BMP,PDF,doc,docx,xls,xlsx,ppt,pptx,rtf,txt,zip,rar,vsd,dwg,mp4,avi,3gp,rmvb,rm,wmv"
            limit="10"
            displayType="table"
            isInputEdit=""
            :configAttributes="{}"
            :multiple="true"
          >
            <span slot="labeldesc">附件</span>
          </eip-attachment>
        </el-form-item>
        <el-form-item label="备注:" prop="remark">
          <el-input v-model="formData.remark" type="textarea"></el-input>
        </el-form-item>
        <el-row class="form_head_title" v-if="!isCancle"> 付款后确认 </el-row>
        <el-row v-if="!isCancle">
          <el-col :span="12">
            <el-form-item label="实际收款:" prop="pay_amount">
              <el-input v-model="formData.pay_amount" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="!isCancle">
          <el-col :span="8">
            <el-form-item label="审核人:" prop="reviewer_name">
              <el-input v-model="formData.reviewer_name" placeholder="保存后自动生成" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话:" prop="reviewer_phone">
              <el-input v-model="formData.reviewer_phone" placeholder="保存后自动生成" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="审核时间:" prop="audit_date">
              <el-date-picker v-model="formData.audit_date" format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期" disabled> </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="审核意见:" prop="audit_remark" v-if="!isCancle">
          <el-input v-model="formData.audit_remark" type="textarea" disabled></el-input>
        </el-form-item>
      </el-form>
    </div>
  </el-drawer>
</template>

<script>
import utils from '@/utils.js'
export default {
  data() {
    return {
      drawerSize: '70%',
      formData: {
        payment_time: '',
        payment_no: '',
        payment_amount: 0,
        pay_method: '1',
        payment_status: '1',
        attachment: '',
        order_no: '',
        order_time: '',
        customer_name: '',
        customer_id: '',
        create_user: '',
        contacts: '',
        contacts_phone: '',
        account_key: '',
        account_name: '',
        account_status: '',
        contacts_package: '',
        remark: '',
        recharge_years: 0,
        users_number: 0,
        purchases_number: 0,
        order_amount: 0,
        remarks: '',
        pay_amount: 0
      },
      paymentList: [
        { name: '对公转账', code: '1' },
        { name: '支付宝', code: '2' },
        { name: '微信', code: '3' }
      ],
      tableData: []
    }
  },
  props: {
    show: {
      type: Boolean,
      default: () => false
    },
    isCancle: {
      type: Boolean,
      default: () => false
    },
    paymentId: {
      type: String,
      default: () => ''
    }
  },
  mounted() {
    this.loadData()
  },
  watch: {
    show: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.loadData()
        }
      },
      deep: true
    }
  },
  methods: {
    loadData() {
      if (this.paymentId) {
        this.$http.get('${third}/costcenter/third_payment/' + this.paymentId).then((res) => {
          if (res.data) {
            if (res.data.order_amount) {
              res.data.order_amount = utils.dataTransform(res.data.order_amount)
            }
            if (res.data.payment_amount) {
              res.data.payment_amount = utils.dataTransform(res.data.payment_amount)
            }
            if (res.data.pay_amount) {
              res.data.pay_amount = utils.dataTransform(res.data.pay_amount)
            }
            this.formData = res.data
          }
        })
      }
    },
    //取消/关闭弹窗
    beforeCloseDialog() {
      this.$emit('closePaymentRecord')
    }
  }
}
</script>
<style scoped>
.dialog-header-title {
  border-bottom: 1px solid #ebeef5;
  padding-bottom: 10px;
}

.dialog-header-title > span {
  border-left: 3px solid #2761ff;
  font-weight: 700;
  font-size: 14px;
  padding-left: 10px;
  color: #666;
}
/deep/.el-dialog__body {
  padding: 10px 20px 30px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
.botton_button {
  display: flex;
  text-align: center;
  justify-content: center;
}
.form_head_title {
  height: 35px;
  color: #377cff;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;
}
/deep/.el-form-item--mini.el-form-item {
  margin-bottom: 0px;
}
.tips {
  padding-left: 120px;
  font-size: 14px;
  color: #101010;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 190px;
}
</style>
